// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/font_icon/iconfont.css
// module id = 4UG9
// module chunks = 2